import React from 'react';
import { Form, Input, FormItemProps, InputProps } from 'antd';
import { useTrans } from 'base/utils/i18n';

type FormEmailProps = FormItemProps & {
    showLabel?: boolean;
    inputProps?: InputProps;
};

export const FormEmail: React.FC<FormEmailProps> = props => {
    const { t } = useTrans()
    const defaultLabel = t('web_form_email_label');

    const {
        showLabel = true,
        label = defaultLabel,
        name = 'email',
        rules = [
            { required: true, message: t('web_form_email_empty_tip') },
            {
                type: 'email',
                message: t('web_form_email_invalid_tip')
            },
        ],
        inputProps = {},
        ...rest
    } = props;

    const itemProps: FormItemProps = {
        ...rest,
        label: showLabel ? label : null,
        name,
        rules,
        normalize: (value = '', prevValue, prevValues) => value.trim()
    };

    const iptProps: InputProps = {
        placeholder: showLabel ? undefined : defaultLabel,
        ...inputProps,
    };

    return (
        <>
            {!itemProps.label && ( // 为空时 默认隐藏的label
                <label
                    className={'visually-hidden'}
                    htmlFor={inputProps.id || itemProps?.name as string}
                >
                    {inputProps.placeholder}
                </label>
            )}

            <Form.Item {...itemProps}>
                <Input {...iptProps}/>
            </Form.Item>
        </>
    )
};

export default FormEmail;